export default __webpack_public_path__ + "static/media/drag.13c5ec13.png";